<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { VISIT_DETAIL_TEXT } from '../utils/visitDetailPresenter';

defineProps({
  visitorId: { type: [String, Number], default: '' },
});

const emit = defineEmits(['openProfile', 'reload']);

const RELOAD_LABEL = 'Atualizar sugestões';
</script>

<template>
  <div class="grid gap-4 rounded-lais-sm bg-lais-bg-soft p-4">
    <span
      class="w-fit rounded-full bg-lais-gold/20 px-2 py-0.5 text-[11px] font-bold uppercase text-lais-text"
    >
      {{ VISIT_DETAIL_TEXT.EXTRA_VISITS_EMPTY_TAG }}
    </span>
    <div class="grid gap-1">
      <h3 class="text-[18px] font-semibold text-lais-text">
        {{ VISIT_DETAIL_TEXT.EXTRA_VISITS_EMPTY_TITLE }}
      </h3>
      <p class="text-[13px] leading-relaxed text-lais-text-body">
        {{ VISIT_DETAIL_TEXT.EXTRA_VISITS_EMPTY_SUBTITLE }}
      </p>
    </div>
    <div class="flex flex-wrap gap-2">
      <LaisPrimaryButton
        v-if="visitorId"
        icon="i-lucide-user-round-search"
        @click="emit('openProfile')"
      >
        {{ VISIT_DETAIL_TEXT.EXTRA_VISITS_EMPTY_BUTTON }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-refresh-cw"
        @click="emit('reload')"
      >
        {{ RELOAD_LABEL }}
      </LaisPrimaryButton>
    </div>
  </div>
</template>
